import api from '../api/axios';

export interface Ministry {
    id: number;
    ministry_name: string;
    ministry_code: string | null;
    created_at?: string;
    updated_at?: string;
}

export const getMinistries = async (params?: { page?: number; per_page?: number; search?: string }) => {
    return api.get('/superadmin/ministries', { params });
};

export const createMinistry = async (data: Partial<Ministry>) => {
    return api.post('/superadmin/ministries', data);
};

export const updateMinistry = async (id: number, data: Partial<Ministry>) => {
    return api.put(`/superadmin/ministries/${id}`, data);
};

export const deleteMinistry = async (id: number) => {
    return api.delete(`/superadmin/ministries/${id}`);
};
